import { render, staticRenderFns } from "./deudor.vue?vue&type=template&id=636187fa&scoped=true"
import script from "./deudor.vue?vue&type=script&lang=js"
export * from "./deudor.vue?vue&type=script&lang=js"
import style0 from "./deudor.vue?vue&type=style&index=0&id=636187fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636187fa",
  null
  
)

export default component.exports